const initialColorModeName = 'light'
export default initialColorModeName
